import React, { useMemo } from "react"

const PaginationControls = ({ currentPage, totalPages, onPrev, onNext, onGoToPage, itemsPerPage, filteredPlants }) => {
  const getPagination = () => {
    const pages = []

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i)
    } else if (currentPage <= 4) {
      pages.push(1, 2, 3, 4, 5, "...", totalPages)
    } else if (currentPage >= totalPages - 3) {
      pages.push(1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages)
    } else {
      pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages)
    }

    return pages
  }

  const pages = useMemo(() => getPagination(), [currentPage, totalPages])

  const getPagePriorityStatus = (pageNumber) => {
    const start = (pageNumber - 1) * itemsPerPage
    const end = start + itemsPerPage
    const items = filteredPlants.slice(start, end)

    let has4 = false
    let has3 = false
    let has2 = false

    for (const p of items) {
      const st = Number(p?.siteStatus)
      if (st === 4) {
        has4 = true
        break
      }
      if (st === 3) has3 = true
      if (st === 2) has2 = true
    }

    if (has4) return 4
    if (has3) return 3
    if (has2) return 2
    return 1
  }

  const getPageBorderColor = (pageNumber) => {
    const st = getPagePriorityStatus(pageNumber)
    if (st === 1) return null
    if (st === 4) return "#E53935" // đỏ
    if (st === 3) return "#FF8A00" // cam
    return "#F4B400" // vàng
  }

  const getRangePriorityStatus = (fromPage, toPage) => {
    let has4 = false
    let has3 = false
    let has2 = false

    for (let page = fromPage + 1; page <= toPage - 1; page++) {
      const st = getPagePriorityStatus(page)
      if (st === 4) {
        has4 = true
        break
      }
      if (st === 3) has3 = true
      if (st === 2) has2 = true
    }

    if (has4) return 4
    if (has3) return 3
    if (has2) return 2
    return 1
  }

  const getEllipsisTextColor = (fromPage, toPage) => {
    const st = getRangePriorityStatus(fromPage, toPage)
    if (st === 4) return "#E53935"
    if (st === 3) return "#FF8A00"
    if (st === 2) return "#F4B400"
    return "#888"
  }

  return (
    <div style={{ display: "flex", gap: 3, alignItems: "center", justifyContent: "center" }}>
      {/* Prev button */}
      <button
        onClick={onPrev}
        disabled={currentPage === 1}
        className="hover-page"
        style={{
          padding: "2px 4px",
          borderWidth: "0px",
          borderRadius: 8,
          minHeight: 28,
          minWidth: 28,
          background: currentPage === 1 ? "#f9f9f9" : "#fff",
          color: currentPage === 1 ? "#999" : "#000",
          cursor: currentPage === 1 ? "not-allowed" : "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <img
          src={`${process.env.PUBLIC_URL}/icons/arrow_left.svg`}
          alt="arrow_left"
          style={{ width: 14, height: 14 }}
        />
      </button>

      {/* Pages */}
      {pages.map((p, idx) =>
        p === "..." ? (
          (() => {
            const left = (() => {
              for (let i = idx - 1; i >= 0; i--) if (pages[i] !== "...") return pages[i]
              return null
            })()

            const right = (() => {
              for (let i = idx + 1; i < pages.length; i++) if (pages[i] !== "...") return pages[i]
              return null
            })()

            const color = typeof left === "number" && typeof right === "number" ? getEllipsisTextColor(left, right) : "#888"

            return (
              <span
                key={`ellipsis-${idx}`}
                style={{ padding: "5px 10px", color }}>
                ...
              </span>
            )
          })()
        ) : (
          <button
            key={`page-${p}`}
            onClick={() => onGoToPage(p)}
            className="hover-page"
            style={{
              padding: "5px 4px",
              borderRadius: 8,
              border: (() => {
                const c = getPageBorderColor(p)
                return c ? `1px solid ${c}` : "0px solid #fff"
              })(),
              background: p === currentPage ? "#ccc" : "#fff",
              color: p === currentPage ? "#1F1F21" : "#000",
              cursor: "pointer",
              fontFamily: "noto-sans",
              fontWeight: 500,
              fontSize: "12px",
              lineHeight: "140%",
              letterSpacing: "2%",
              textAlign: "center",
              minHeight: 28,
              minWidth: 28,
            }}>
            {p}
          </button>
        ),
      )}

      {/* Next button */}
      <button
        onClick={onNext}
        disabled={currentPage === totalPages}
        className="hover-page"
        style={{
          padding: "2px 4px",
          borderWidth: "0px",
          borderRadius: 8,
          minHeight: 28,
          minWidth: 28,
          background: currentPage === totalPages ? "#f9f9f9" : "#fff",
          color: currentPage === totalPages ? "#999" : "#000",
          cursor: currentPage === totalPages ? "not-allowed" : "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <img
          src={`${process.env.PUBLIC_URL}/icons/arrow_right.svg`}
          alt="arrow_right"
          style={{ width: 14, height: 14 }}
        />
      </button>
    </div>
  )
}

export default PaginationControls
